import React, { lazy, Suspense, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import NavBar from "./Components/Navigations/NavBar";
import CandidatesNavbar from "./Components/Benchcandidates/Candidatesnavbar";
import Loader from "./Components/loader/Loader";
import { userSelector } from "./Components/user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import LoginPage from "./Components/login/LoginPage";
import Companyinfo from "./Components/Companies/Companies";
import CalendarComponent from "./Components/Candidates/Calender";
import { appSelector } from "./Components/redux/selector";
import { closeSnackBarAction } from "./Components/redux/action";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import {
  checkSessionTimeout,
  resetSessionTimer,
} from "./Components/utils/SessionTimeout";
import MailContacts from "./Components/candidatesPage/MailContacts";
import JnpRedirect from "./Components/login/JnpRedirect";
import Candidateslist from "./Components/Benchcandidates/Candidateslist";
import Inactivecandidates from "./Components/candidatesPage/Inactivecandidates";
import Todolist from "./Components/Benchcandidates/Todolist";
import Sources from "./Components/candidatesPage/Sources";
import Admindashboard from "./Components/Admin/AdminRcruiterpage/Admin_Allocation";
import AdminDashboard from "./Components/Admin/AdminRcruiterpage/Admin_dashboard";

import BsCandidates from "./Components/Admin/BsCandidates";
import CandidateProfiles from "./Components/Benchcandidates/Profiles/CandidateProfiles";
import CandidatesDocuments from "./Components/Benchcandidates/Documents/CandidatesDocuments";
import CandidateDashboard from "./Components/Benchcandidates/CandidateDashboard";
import Interestcandidates from "./Components/candidatesPage/Interestcandidates";
import Adminsettings from "./Components/Settings/Adminsettings";
import Profilesettings from "./Components/Settings/Profilesettings";
import RecruiterProfileSettings from "./Components/Settings/RecruiterProfilesettings";
import Admincandidates from "./Components/Admin/AdminCandidatePage/Admincandidates";
import AdminAllocation from "./Components/Admin/AdminRcruiterpage/AdminAllocation";
import AdminInactiveRecruiters from "./Components/Admin/AdminRcruiterpage/AdmininactiveRecruiters";
import Home from "./Home";
import CandidateJobRoleReports from "./Components/Admin/AdminCandidatePage/CandidateJobRoleReports";
import Addjob from "./Components/Admin/AdminRcruiterpage/Addjob";
import MyCandidates from "./Components/MyCandidates";
import ZohoCallback from "./Components/MyCandidates/CandidatesTabs/Submissions/ZohoCallback";
import Resumeselection from "./Components/MyCandidates/ResumeSelection/ResumeSelectionView";
import OptimiseView from "./Components/OptimiseResume/OptimiseView";
import AdvancedOptimiseView from "./Components/AdvancedOptimiseResume/AdvancedOptimiseView";
import Resumecontext from "./Components/OptimiseResume/Resumecontext";
import Settingsmain from "./Components/Settings/Settings_new";
import Voicecall from "./Components/Admin/Voicecall/Voicecall";
import Recruitervoicecall from "./Components/Admin/Recruiter/Recruitervoicecall";
import Recruitersentmail from "./Components/Admin/Recruiter/Recruitersentmail";
import { GoogleOAuthProvider } from '@react-oauth/google';
import ResetPassword from "./Components/login/ResetPassword";
import JobFairCandidates from "./Components/Admin/JobFairCandidates/JobFairCandidates";
import ChatBot from "./Components/ChatBot";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";
import AITermsOfUse from "./AITermsOfUse";
import AboutUs from "./AboutUs";
import Blog from "./Blog";
import BlogPost from "./BlogPost";


const GMAIL_CLIENT_ID = "227946764528-98bguetrtd0l00v2klf220jcu9lalfk2.apps.googleusercontent.com";
// const CLIENT_ID = "186781977079-v43haighjiue1gsi6e9cj9e0028d3li2.apps.googleusercontent.com";
const Dashboard = lazy(() =>
  import("./Components/dashboard/Recruiterdashboard")
);
const Candidates = lazy(() => import("./Components/candidatesPage/Candidates"));
const MailJobAcceptByCandidate = lazy(() =>
  import("./Components/mailRedirections/JobAcceptByCandidate")
);

const MailProfileAcceptedByVendor = lazy(() =>
  import("./Components/mailRedirections/ProfileAcceptedByVendor")
);
const MailProfileRejectedByVendor = lazy(() =>
  import("./Components/mailRedirections/ProfileRejectedByVendor")
);
const MailJobRejectedByCandidate = lazy(() =>
  import("./Components/mailRedirections/JobRejectedByCandidate")
);

const fetchData = async () => {
  await new Promise((resolve) => setTimeout(resolve, 2000));
};

const PrivateRoute = ({ element }) => {
  const { user } = useSelector(userSelector);

  const isAuthenticated = user !== null && Object.keys(user).length > 0;

  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

const App = () => {
  const [loading, setLoading] = useState(true);
  const { user } = useSelector(userSelector);
  const { alertMessage, openAlert, alertStatus } = useSelector(appSelector);
  const dispatch = useDispatch();
  const [jobTitle, setJobTitle] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [resumeImage, setResumeImage] = useState("");
  const [resumeImageObject, setResumeImageObject] = useState("");
  const [summary, setSummary] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [degree, setDegree] = useState("");
  const [stream, setStream] = useState("");
  const [userId, setUserId] = useState("");
  const [institute, setInstitute] = useState("");
  const [year, setYear] = useState("");
  const [projecttitle, setProjecttitle] = useState("");
  const [role, setRole] = useState("");
  const [client, setClient] = useState("");
  const [country, setCountry] = useState("");
  const [countryLabel, setCountryLabel] = useState("United States");
  const [city, setCity] = useState("");
  const [visaType, setVisaType] = useState("");
  const [visaTypeLabel, setVisaTypeLabel] = useState("");
  const [jobType, setJobType] = useState("");
  const [jobTypeLabel, setjobTypeLabel] = useState("");
  const [cityLabel, setCityLabel] = useState("");
  const [state, setState] = useState("");
  const [stateLabel, setStateLabel] = useState("");
  const [startdate, setStartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const [website, setWebsite] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [skillsToHighlight, setSkillsToHighlight] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [gitHub, setGitHub] = useState("");
  const [hackerRank, setHackerRank] = useState("");
  const [leetCode, setLeetCode] = useState("");

  const [searchResumeTitle, setSearchResumeTitle] = useState("");
  const [resumetemplate, setResumeTemplate] = useState("0");
  const [skills, setSkills] = useState([
    {
      category: "",
      skills: [],
    },
  ]);
  const [aiSkills, setAISkills] = useState([]);
  const [certificate, setCertificate] = useState([
    { certName: "", certYear: "" },
  ]);
  const [education, setEducation] = useState([
    { university: "", yearofpassing: "", degree: "" },
  ]);
  const [project, setProject] = useState([
    {
      projectTitle: "",
      country: "",
      country_id: "",
      state: "",
      state_id: "",
      city: "",
      city_id: "",
      responsibilities: "",
      date_start: "",
      organization: "",
      date_end: "",
      jobtitle: "",
      description: "",
    },
  ]);
  const [experience, setExperience] = useState([]);
  const [skillNames, setSkillNames] = useState([]);
  const [finish, setFinish] = useState(false);
  const [finishOne, setFinishOne] = useState(false);
  const [certificateLogo, setCertificateLogo] = useState("");
  const [statesList, setStatesList] = useState([]);

  useEffect(() => {
    const fetchDataAndStopLoading = async () => {
      try {
        await fetchData();
      } finally {
        setLoading(false);
      }
    };

    fetchDataAndStopLoading();
  }, []);

  // session time code start
  useEffect(() => {
    resetSessionTimer();

    const handleUserActivity = () => {
      resetSessionTimer();
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
    };
  }, [dispatch, user]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkSessionTimeout(dispatch, user);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch, user]);
  // session time code end

  if (loading) {
    return <Loader loading={loading} />;
  }

  const handleAlertClose = () => {
    dispatch(closeSnackBarAction());
  };

  return (
    <>
      <GoogleOAuthProvider clientId={GMAIL_CLIENT_ID}>
        <Resumecontext.Provider
          value={{
            jobTitle,
            updateJobTitle: (value) => setJobTitle(value),
            website,
            updateWebsite: (value) => setWebsite(value),
            linkedIn,
            updateLinkedIn: (value) => setLinkedIn(value),
            gitHub,
            updateGitHub: (value) => setGitHub(value),
            leetCode,
            updateLeetCode: (value) => setLeetCode(value),
            hackerRank,
            updateHackerRank: (value) => setHackerRank(value),
            portfolio,
            updatePortfolio: (value) => setPortfolio(value),
            name,
            updateName: (value) => setName(value),
            email,
            updateEmail: (value) => setEmail(value),
            phone,
            updatePhone: (value) => setPhone(value),
            summary,
            updateSummary: (value) => setSummary(value),
            degree,
            updateDegree: (value) => setDegree(value),
            resumeImage,
            updateResumeImage: (value) => setResumeImage(value),
            resumeImageObject,
            updateResumeImageObject: (value) => setResumeImageObject(value),
            institute,
            updateInstitute: (value) => setInstitute(value),
            stream,
            updateStream: (value) => setStream(value),
            year,
            updateYear: (value) => setYear(value),
            skills,
            updateSkills: (value) => setSkills(value),
            aiSkills,
            updateAISkills: (value) => setAISkills(value),
            userId,
            updateUserId: (value) => setUserId(value),
            password,
            updatePassword: (value) => setPassword(value),
            confirmPassword,
            updateConfirmPassword: (value) => setConfirmPassword(value),
            projecttitle,
            updateProjecttitle: (value) => setProjecttitle(value),
            client,
            updateClient: (value) => setClient(value),
            role,
            updateRole: (value) => setRole(value),
            country,
            updateCountry: (value) => setCountry(value),
            countryLabel,
            updateCountryLabel: (value) => setCountryLabel(value),
            state,
            updateState: (value) => setState(value),
            stateLabel,
            updateStateLabel: (value) => setStateLabel(value),
            city,
            updateCity: (value) => setCity(value),
            visaType,
            updateVisaType: (value) => setVisaType(value),
            visaTypeLabel,
            updateVisaTypeLabel: (value) => setVisaTypeLabel(value),
            jobType,
            updateJobType: (value) => setJobType(value),
            jobTypeLabel,
            updateJobTypeLabel: (value) => setjobTypeLabel(value),
            cityLabel,
            updateCityLabel: (value) => setCityLabel(value),
            startdate,
            updateStartdate: (value) => setStartdate(value),
            enddate,
            updateEnddate: (value) => setEnddate(value),
            certificate,
            updateCertificate: (value) => setCertificate(value),
            education,
            updateEducation: (value) => setEducation(value),
            project,
            updateProject: (value) => setProject(value),
            experience,
            updateExperience: (value) => setExperience(value),
            skillNames,
            updateSkillNames: (value) => setSkillNames(value),
            resumetemplate,
            updateResumetemplate: (value) => setResumeTemplate(value),
            finish,
            updateFinish: (value) => setFinish(value),
            finishOne,
            updateFinishOne: (value) => setFinishOne(value),
            certificateLogo,
            updateCertificateLogo: (value) => setCertificateLogo(value),
            statesList,
            getStates: (value) => setStatesList(value),
          }}
        >
          <React.Fragment>
            <ToastContainer
              className="toaster-container"
              position="top-right"
              autoClose={2500}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <Router>
              <Suspense fallback={<Loader loading={loading} />}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      user !== null && Object.keys(user).length > 0 ? (
                        <NavBar>
                          {user.usertype == 13 ? (
                            <Navigate to="/admin-dashboard" replace />
                          ) : user.usertype == 6 ? (
                            <CandidateDashboard />
                          ) : user.usertype == 3 ? (
                            <Dashboard />
                          ) : null}
                        </NavBar>
                      ) : (
                        <Home />
                      )
                    }
                  />
                  <Route path="/home" element={<Home />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/resetpassword/:emailToken" element={<ResetPassword />} />
                  <Route path="/jnp-redirect" element={<JnpRedirect />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                  <Route path="/ai-terms-of-use" element={<AITermsOfUse />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:id" element={<BlogPost />} />


                  <Route
                    path="/:userid/:candidateid/:jobid/:statusid/mail-job-accepted"
                    element={<MailJobAcceptByCandidate />}
                  />

                  <Route
                    path="/:userid/:candidateid/:jobid/:statusid/mail-job-rejected"
                    element={<MailJobRejectedByCandidate />}
                  />

                  <Route
                    path="/:userid/:candidateid/:jobid/:statusid/mail-profile-accepted"
                    element={<MailProfileAcceptedByVendor />}
                  />
                  <Route
                    path="/:userid/:candidateid/:jobid/:statusid/mail-profile-rejected"
                    element={<MailProfileRejectedByVendor />}
                  />
                  <Route
                    path="/my-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <MyCandidates />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route path="/zoho/callback" element={<ZohoCallback />} />

                  <Route
                    path="/candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Candidates />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/inactive-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Inactivecandidates />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/interested-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Interestcandidates />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/profile-settings"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Profilesettings />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/recruiter-profile-settings"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <RecruiterProfileSettings />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/admin-settings"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Adminsettings />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/profile-view"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Settingsmain />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/companies"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Companyinfo />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/sources"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Sources />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/calendar"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <CalendarComponent />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/resume-selection"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Resumeselection />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/contacts"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <MailContacts />
                          </NavBar>
                        }
                      />
                    }
                  />


                  <Route
                    path="/voice-call"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Voicecall />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/recruiter-voice-call"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Recruitervoicecall />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/sent-mail"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Recruitersentmail />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/candidate-dashboard"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <CandidateDashboard />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/candidates-list"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Candidateslist />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/resume/optimise/:resumeid"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <OptimiseView />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/resume/advanced-optimise/:resumeid"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <AdvancedOptimiseView />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/todo-list"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Todolist />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/profiles"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <CandidateProfiles />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/documents"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <CandidatesDocuments />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/admin-dashboard"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <AdminDashboard />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/admin-allocation"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Admindashboard />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/admin-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Admincandidates />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/admin-allocation"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <AdminAllocation />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/adminin-active-recruiters"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <AdminInactiveRecruiters />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/reports"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <CandidateJobRoleReports />
                          </NavBar>
                        }
                      />
                    }
                  />

                  <Route
                    path="/bs-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <BsCandidates />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/add-job"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <Addjob />
                          </NavBar>
                        }
                      />
                    }
                  />
                  <Route
                    path="/job-fair-candidates"
                    element={
                      <PrivateRoute
                        element={
                          <NavBar>
                            <JobFairCandidates />
                          </NavBar>
                        }
                      />
                    }
                  />
                </Routes>
              </Suspense>
              <ChatBot />
            </Router>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              onClose={handleAlertClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MuiAlert onClose={handleAlertClose} severity={alertStatus}>
                {alertMessage}
              </MuiAlert>
            </Snackbar>
          </React.Fragment>
        </Resumecontext.Provider>
      </GoogleOAuthProvider>
    </>
  );
};

export default App;
